import { scaleToFit } from '../../Utils/Utils';

enum Events {
    OnLoad = 'OnLoad',
    OnError = 'OnError',
    OnComplete = 'OnComplete',
}

interface IConstructorParameters {
    url: string;
    width?: number;
    height?: number;
    defaultImage?: string;
    scale?: number;
}

export class EmbeddedSprite extends PIXI.Sprite {
    public static readonly events = Events;
    protected readonly defaultImage: string;

    constructor({
        url,
        width,
        height,
        defaultImage = 'mapui/no-avatar',
        scale,
    }: IConstructorParameters) {
        super();
        this.defaultImage = defaultImage;
        this.anchor.set(0.5);
        this.on(EmbeddedSprite.events.OnComplete, () => {
            if (!scale && (width || height)) {
                this.scale.set(scaleToFit(this.width, this.height, width, height));
            } else if (scale) {
                this.scale.set(scale);
            }
        });
        try {
            const urlObject = new URL(url);
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.src = urlObject.href;
            img.addEventListener('load', () => this.onLoad(img));
            img.addEventListener('error', this.onError.bind(this));
        } catch (e) {
            if (PIXI.utils.TextureCache[url]) {
                this.onLoad(url);
            } else {
                this.onError();
            }
        }
    }

    protected onLoad(img: HTMLImageElement | string) {
        this.texture = PIXI.Texture.from(img);
        this.emit(EmbeddedSprite.events.OnLoad);
        this.emit(EmbeddedSprite.events.OnComplete);
    }

    protected onError() {
        this.texture = PIXI.utils.TextureCache[this.defaultImage];
        this.emit(EmbeddedSprite.events.OnError);
        this.emit(EmbeddedSprite.events.OnComplete);
    }
}
